module.exports = __webpack_public_path__ + "img/clogo.ba6078a1.png";